import { datadogRum } from '@datadog/browser-rum';
import { RepeatIcon, Button } from '@iheartjane/reefer';
import { useLocation, useRouteError } from 'react-router';

import { RouterErrorPage } from '@jane/shared-ecomm/components';

import type { RootLoaderType } from '../data-access';
import { useTypedRouteLoaderData } from '../hooks';

function ErrorPageButton() {
  const loaderData = useTypedRouteLoaderData<RootLoaderType>('root');
  const location = useLocation();
  const mobilePath =
    location.pathname.includes('/mobile') &&
    (location.pathname.includes('/login') ||
      location.pathname.includes('/link-bank'));

  if (!loaderData?.storeId) return null;

  return (
    <Button
      label="Reload"
      to={`/stores/${loaderData.storeId}${mobilePath ? `/mobile/login` : ``}`}
      startIcon={<RepeatIcon />}
    />
  );
}

export function ErrorPage() {
  const error = useRouteError();

  datadogRum.addError('Router error', error as Error);

  return (
    <RouterErrorPage
      button={<ErrorPageButton />}
      legacy={true}
      trackError={datadogRum.addError}
      withReeferThemeProvider
      whiteLabel
    />
  );
}
